/*
 * OASIS NATION — interactivity layer
 * Vanilla JS, no dependencies. Progressive enhancement only.
 */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.oasis-reveal');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Animated counters ---------- */
  function animateCount(el) {
    var target = parseFloat(el.getAttribute('data-count-to')) || 0;
    var dur = 1400;
    var startTs = null;
    function step(ts) {
      if (!startTs) startTs = ts;
      var p = Math.min((ts - startTs) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased).toLocaleString();
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function initCounters() {
    var els = document.querySelectorAll('[data-count-to]');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.textContent = (parseFloat(el.getAttribute('data-count-to')) || 0).toLocaleString(); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { animateCount(entry.target); io.unobserve(entry.target); }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Sweepstakes progress fill ---------- */
  function initProgress() {
    document.querySelectorAll('.oasis-sweep__progress span').forEach(function (bar) {
      var pct = bar.getAttribute('data-pct') || '0';
      requestAnimationFrame(function () {
        setTimeout(function () { bar.style.width = pct + '%'; }, 200);
      });
    });
  }

  /* ---------- Marquee: duplicate track for seamless loop ---------- */
  function initMarquee() {
    document.querySelectorAll('.oasis-marquee__track').forEach(function (track) {
      if (track.dataset.cloned) return;
      track.dataset.cloned = '1';
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  /* ---------- Sticky add-to-cart ---------- */
  function initStickyAtc() {
    var bar = document.querySelector('.oasis-sticky-atc');
    if (!bar) return;
    var anchor = document.querySelector('[data-sticky-atc-anchor]');
    var stickyBtn = bar.querySelector('[data-sticky-atc-button]');
    var mainForm = document.querySelector('product-form form, form[data-type="add-to-cart-form"]');

    if (stickyBtn && mainForm) {
      stickyBtn.addEventListener('click', function (e) {
        e.preventDefault();
        var realBtn = mainForm.querySelector('[name="add"]');
        if (realBtn) realBtn.click();
      });
    }

    // Auto-anchor on the main buy buttons if no explicit anchor was set
    if (!anchor) {
      anchor = document.querySelector('.product-form__buttons') ||
               document.querySelector('product-form') ||
               mainForm;
    }
    if (!anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Show the sticky bar once the main add-to-cart has scrolled out of view
        if (entry.boundingClientRect.top < 0 && !entry.isIntersecting) {
          bar.classList.add('is-visible');
          // Mirror the state (and the bar's real height) onto <body> so the Noem
          // chat launcher can lift clear of the Add to cart button. See oasis-custom.css.
          document.documentElement.style.setProperty('--oasis-atc-h', bar.offsetHeight + 'px');
          document.body.classList.add('oasis-atc-on');
        } else if (entry.isIntersecting) {
          bar.classList.remove('is-visible');
          document.body.classList.remove('oasis-atc-on');
        }
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  /* ---------- Free-shipping progress (cart) ---------- */
  function updateShipBars() {
    document.querySelectorAll('.oasis-ship-bar').forEach(function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10); // smallest currency unit
      var total = parseInt(bar.getAttribute('data-total'), 10);
      if (isNaN(threshold) || isNaN(total) || threshold <= 0) return;
      var fill = bar.querySelector('.oasis-ship-bar__fill');
      var textEl = bar.querySelector('.oasis-ship-bar__text');
      var pct = Math.min((total / threshold) * 100, 100);
      if (fill) requestAnimationFrame(function () { fill.style.width = pct + '%'; });
      if (textEl) {
        if (total >= threshold) {
          textEl.innerHTML = textEl.getAttribute('data-success') || 'You unlocked free shipping';
        } else {
          var remaining = ((threshold - total) / 100).toFixed(2);
          var tpl = textEl.getAttribute('data-remaining') || "You're <b>$[amount]</b> away from free shipping";
          textEl.innerHTML = tpl.replace('[amount]', remaining);
        }
      }
    });
  }
  function initShipBar() {
    updateShipBars();
    // Recompute whenever the cart changes (Dawn re-renders the drawer/cart section)
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(updateShipBars, 60); });
      }
    } catch (e) { /* pub/sub not available, no-op */ }
  }

  /* ---------- Custom cursor ---------- */
  function initCursor() {
    if (!window.__OASIS_CUSTOM_CURSOR__) return; // off by default; opt in via Theme settings > Animations
    var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!fine || reduceMotion || document.querySelector('.oasis-cursor')) return;

    var ring = document.createElement('div');
    ring.className = 'oasis-cursor';
    var label = document.createElement('span');
    label.className = 'oasis-cursor__label';
    ring.appendChild(label);
    var dot = document.createElement('div');
    dot.className = 'oasis-cursor__dot';
    document.body.appendChild(ring);
    document.body.appendChild(dot);
    document.body.classList.add('oasis-cursor-on');

    var mx = window.innerWidth / 2, my = window.innerHeight / 2;
    var rx = mx, ry = my;
    document.addEventListener('mousemove', function (e) {
      mx = e.clientX; my = e.clientY;
      dot.style.transform = 'translate3d(' + mx + 'px,' + my + 'px,0) translate(-50%,-50%)';
    });
    document.addEventListener('mousedown', function () { ring.classList.add('is-down'); });
    document.addEventListener('mouseup', function () { ring.classList.remove('is-down'); });

    function loop() {
      rx += (mx - rx) * 0.18;
      ry += (my - ry) * 0.18;
      ring.style.transform = 'translate3d(' + rx + 'px,' + ry + 'px,0) translate(-50%,-50%)';
      requestAnimationFrame(loop);
    }
    requestAnimationFrame(loop);

    function setState(target) {
      ring.classList.remove('is-link', 'is-cta', 'is-drag');
      label.textContent = '';
      if (!target) return;
      var cta = target.closest('.button, [type="submit"], .oasis-btn-gold');
      var drag = target.closest('[data-cursor="drag"]');
      var link = target.closest('a, button, [role="button"], .card-wrapper');
      if (drag) { ring.classList.add('is-drag'); label.textContent = 'Drag'; }
      else if (cta) { ring.classList.add('is-cta'); label.textContent = cta.getAttribute('data-cursor-label') || 'Shop'; }
      else if (link) { ring.classList.add('is-link'); }
    }
    document.addEventListener('mouseover', function (e) { setState(e.target); });
  }

  /* ---------- Scroll progress line ---------- */
  function initScrollProgress() {
    var bar = document.querySelector('.oasis-scroll-progress');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'oasis-scroll-progress';
      document.body.appendChild(bar);
    }
    var ticking = false;
    function update() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var pct = h > 0 ? (window.scrollY / h) * 100 : 0;
      bar.style.width = pct + '%';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Magnetic buttons ---------- */
  function initMagnetic() {
    if (reduceMotion) return;
    var btns = document.querySelectorAll('.button, .oasis-magnetic');
    btns.forEach(function (btn) {
      if (btn.dataset.magnetic) return;
      btn.dataset.magnetic = '1';
      var strength = 0.35;
      btn.addEventListener('mousemove', function (e) {
        var r = btn.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2;
        var y = e.clientY - r.top - r.height / 2;
        btn.style.transform = 'translate(' + x * strength + 'px,' + y * strength + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transform = '';
      });
    });
  }

  /* ---------- 3D tilt on product cards ---------- */
  function initTilt() {
    if (reduceMotion) return;
    var cards = document.querySelectorAll('.card-wrapper');
    cards.forEach(function (card) {
      if (card.dataset.tilt) return;
      card.dataset.tilt = '1';
      card.classList.add('oasis-tilt');
      var media = card.querySelector('.card__media') || card.querySelector('.card');
      if (!media) return;
      if (!card.querySelector('.oasis-tilt__glint')) {
        var glint = document.createElement('span');
        glint.className = 'oasis-tilt__glint';
        (card.querySelector('.card__inner') || media).appendChild(glint);
      }
      var glintEl = card.querySelector('.oasis-tilt__glint');
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width;
        var py = (e.clientY - r.top) / r.height;
        var rotY = (px - 0.5) * 7;
        var rotX = (0.5 - py) * 7;
        media.style.transform = 'perspective(900px) rotateX(' + rotX + 'deg) rotateY(' + rotY + 'deg)';
        if (glintEl) { glintEl.style.setProperty('--gx', px * 100 + '%'); glintEl.style.setProperty('--gy', py * 100 + '%'); }
      });
      card.addEventListener('mouseleave', function () { media.style.transform = ''; });
    });
  }

  /* ---------- Mask-wipe text reveal ---------- */
  function initMask() {
    var els = document.querySelectorAll('.oasis-mask');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Rotating word-cycle headline ---------- */
  function initWordCycle() {
    document.querySelectorAll('[data-word-cycle]').forEach(function (root) {
      if (root.dataset.cycling) return;
      var words = root.querySelectorAll('.oasis-hero__word');
      if (words.length < 2) {
        if (words[0]) words[0].classList.add('is-active');
        return;
      }
      root.dataset.cycling = '1';
      var i = 0;
      words[0].classList.add('is-active');
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 2200;
      setInterval(function () {
        var current = words[i];
        current.classList.remove('is-active');
        current.classList.add('is-out');
        i = (i + 1) % words.length;
        var next = words[i];
        next.classList.remove('is-out');
        next.classList.add('is-active');
        // clear the is-out from the one before so it resets cleanly
        setTimeout(function () { current.classList.remove('is-out'); }, 520);
      }, interval);
    });
  }

  /* ---------- Hero mouse parallax ---------- */
  function initHeroParallax() {
    if (reduceMotion) return;
    var hero = document.querySelector('.oasis-hero');
    if (!hero) return;
    var media = hero.querySelector('.oasis-hero__media');
    var inner = hero.querySelector('.oasis-hero__inner');
    var glow = hero.querySelector('[data-hero-glow]');
    hero.addEventListener('mousemove', function (e) {
      var r = hero.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      if (media) media.style.transform = 'translate3d(' + x * -18 + 'px,' + y * -18 + 'px,0) scale(1.06)';
      if (inner) inner.style.transform = 'translate3d(' + x * 10 + 'px,' + y * 10 + 'px,0)';
      if (glow) {
        glow.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        glow.style.setProperty('--my', (e.clientY - r.top) + 'px');
      }
    });
    hero.addEventListener('mouseleave', function () {
      if (media) media.style.transform = '';
      if (inner) inner.style.transform = '';
    });
    // Scroll fade of hero content
    window.addEventListener('scroll', function () {
      if (!inner) return;
      var op = Math.max(0, 1 - window.scrollY / (window.innerHeight * 0.6));
      inner.style.opacity = op;
    }, { passive: true });
  }

  /* ---------- Garage: drag to scroll + progress ---------- */
  function initGarage() {
    document.querySelectorAll('.oasis-garage').forEach(function (garage) {
      var vp = garage.querySelector('.oasis-garage__viewport');
      var prog = garage.querySelector('.oasis-garage__progress span');
      if (!vp) return;

      // drag to scroll
      var down = false, startX = 0, startScroll = 0, moved = false;
      vp.addEventListener('pointerdown', function (e) {
        down = true; moved = false; startX = e.clientX; startScroll = vp.scrollLeft;
        vp.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 4) moved = true;
        vp.scrollLeft = startScroll - dx;
      });
      window.addEventListener('pointerup', function () { down = false; vp.classList.remove('is-dragging'); });
      // prevent click navigation right after a drag
      vp.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);

      // wheel: translate vertical scroll to horizontal when hovering
      vp.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
          var max = vp.scrollWidth - vp.clientWidth;
          if ((vp.scrollLeft > 0 && vp.scrollLeft < max) || (vp.scrollLeft <= 0 && e.deltaY > 0) || (vp.scrollLeft >= max && e.deltaY < 0)) {
            // only hijack while there is room to scroll horizontally
          }
          vp.scrollLeft += e.deltaY;
          if (vp.scrollLeft > 0 && vp.scrollLeft < max) e.preventDefault();
        }
      }, { passive: false });

      function updateProg() {
        if (!prog) return;
        var max = vp.scrollWidth - vp.clientWidth;
        var pct = max > 0 ? (vp.scrollLeft / max) * 100 : 0;
        prog.style.width = pct + '%';
      }
      vp.addEventListener('scroll', function () { requestAnimationFrame(updateProg); }, { passive: true });
      updateProg();
    });
  }

  /* ---------- Bundle & Save builder ---------- */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function initBundle() {
    document.querySelectorAll('[data-oasis-bundle]').forEach(function (root) {
      if (root.dataset.bound) return;
      root.dataset.bound = '1';

      var discountPct = parseFloat(root.getAttribute('data-discount')) || 0;
      var items = root.querySelectorAll('.oasis-bundle__item');
      var subEl = root.querySelector('[data-bundle-subtotal]');
      var saveEl = root.querySelector('[data-bundle-save]');
      var totalEl = root.querySelector('[data-bundle-total]');
      var wasEl = root.querySelector('[data-bundle-was]');
      var countEl = root.querySelector('[data-bundle-count]');
      var tierFill = root.querySelector('.oasis-bundle__tierbar span');
      var addBtn = root.querySelector('[data-bundle-add]');
      var minForDiscount = parseInt(root.getAttribute('data-min-items'), 10) || 2;

      function recalc() {
        var subtotal = 0, selected = 0;
        items.forEach(function (item) {
          if (item.classList.contains('is-selected')) {
            selected++;
            subtotal += parseInt(item.getAttribute('data-price'), 10) || 0;
          }
        });
        var qualifies = selected >= minForDiscount;
        var save = qualifies ? Math.round(subtotal * (discountPct / 100)) : 0;
        var total = subtotal - save;
        if (subEl) subEl.textContent = formatMoney(subtotal);
        if (saveEl) saveEl.textContent = '-' + formatMoney(save);
        if (totalEl) totalEl.textContent = formatMoney(total);
        if (wasEl) { wasEl.textContent = save > 0 ? formatMoney(subtotal) : ''; }
        if (countEl) countEl.textContent = selected;
        if (tierFill) tierFill.style.width = Math.min(selected / minForDiscount, 1) * 100 + '%';
        if (addBtn) {
          addBtn.disabled = selected === 0;
          var lbl = addBtn.querySelector('[data-bundle-addlabel]');
          if (lbl) lbl.textContent = selected === 0 ? 'Select your pieces' : ('Add ' + selected + (selected === 1 ? ' item' : ' items') + ' to cart');
        }
      }

      items.forEach(function (item) {
        var toggle = function (e) {
          if (e.target.classList.contains('oasis-bundle__variant')) return; // don't toggle when using dropdown
          item.classList.toggle('is-selected');
          recalc();
        };
        item.addEventListener('click', toggle);
      });

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var payload = [];
          items.forEach(function (item) {
            if (!item.classList.contains('is-selected')) return;
            var sel = item.querySelector('.oasis-bundle__variant');
            var id = sel ? sel.value : item.getAttribute('data-variant');
            if (id) payload.push({ id: parseInt(id, 10), quantity: 1 });
          });
          if (!payload.length) return;
          addBtn.classList.add('loading');
          fetch(window.routes ? window.routes.cart_add_url + '.js' : '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: payload })
          }).then(function (r) { return r.json(); }).then(function () {
            addBtn.classList.remove('loading');
            // Open cart drawer if present, else go to cart
            var drawer = document.querySelector('cart-drawer');
            if (drawer && typeof drawer.open === 'function') {
              fetch('/?sections=cart-drawer').then(function(){ window.location.href = '/cart'; });
              drawer.open();
            } else {
              window.location.href = '/cart';
            }
          }).catch(function () {
            addBtn.classList.remove('loading');
            window.location.href = '/cart';
          });
        });
      }

      recalc();
    });
  }

  /* ---------- Quick-add (floating merch tiles) ---------- */
  function oasisCartElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }
  function oasisAddToCart(variantId, trigger) {
    if (!variantId) return;
    var cart = oasisCartElement();
    var body = { items: [{ id: parseInt(variantId, 10), quantity: 1 }] };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    if (trigger) trigger.classList.add('is-loading');
    fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (trigger) trigger.classList.remove('is-loading');
      if (res.status) { window.location.href = '/cart'; return; } // unavailable -> full cart page
      if (trigger) {
        trigger.classList.add('is-added');
        setTimeout(function () { trigger.classList.remove('is-added'); }, 1600);
      }
      if (cart && typeof cart.renderContents === 'function') {
        cart.classList.remove('is-empty');
        cart.renderContents(res);
        if (typeof cart.open === 'function') cart.open();
      } else {
        window.location.href = '/cart';
      }
    }).catch(function () {
      if (trigger) trigger.classList.remove('is-loading');
      window.location.href = '/cart';
    });
  }
  function initQuickAdd() {
    document.querySelectorAll('[data-quick-add]').forEach(function (qa) {
      if (qa.dataset.bound) return;
      qa.dataset.bound = '1';
      var trigger = qa.querySelector('[data-qa-trigger]');
      var pop = qa.querySelector('[data-qa-pop]');
      if (!trigger) return;
      trigger.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (pop) {
          var open = qa.classList.toggle('is-open');
          pop.hidden = !open;
        } else {
          oasisAddToCart(trigger.getAttribute('data-variant'), trigger);
        }
      });
      if (pop) {
        pop.querySelectorAll('.oasis-qa__size').forEach(function (sz) {
          sz.addEventListener('click', function (e) {
            e.preventDefault(); e.stopPropagation();
            if (sz.disabled) return;
            oasisAddToCart(sz.getAttribute('data-variant'), trigger);
            qa.classList.remove('is-open'); pop.hidden = true;
          });
        });
      }
    });
  }

  /* ---------- Sticky "Shop The Drop" bar ---------- */
  function initShopBar() {
    var bar = document.querySelector('[data-shopbar]');
    if (!bar || bar.dataset.bound) return;
    bar.dataset.bound = '1';
    var after = (parseInt(bar.getAttribute('data-reveal-after'), 10) || 90) / 100;
    var footer = document.querySelector('.newsletter') ||
                 document.querySelector('.shopify-section-group-footer-group') ||
                 document.querySelector('footer');
    var ticking = false;
    function update() {
      ticking = false;
      var show = window.scrollY > window.innerHeight * after;
      if (show && footer) {
        var fr = footer.getBoundingClientRect();
        if (fr.top < window.innerHeight - 40) show = false; // step aside near the foot
      }
      bar.classList.toggle('is-visible', show);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  // Close any open size popover when clicking elsewhere (bound once).
  document.addEventListener('click', function (e) {
    document.querySelectorAll('.oasis-qa.is-open').forEach(function (qa) {
      if (!qa.contains(e.target)) {
        qa.classList.remove('is-open');
        var pop = qa.querySelector('[data-qa-pop]');
        if (pop) pop.hidden = true;
      }
    });
  });

  /* ---------- Film grain overlay ---------- */
  function initGrain() {
    if (reduceMotion || document.querySelector('.oasis-grain')) return;
    var g = document.createElement('div');
    g.className = 'oasis-grain';
    document.body.appendChild(g);
  }

  /* ---------- Cursor spotlight on dark sections ---------- */
  function initSpotlight() {
    var sections = document.querySelectorAll('.oasis-garage, .oasis-buildlink, .oasis-sweep, .oasis-bundle');
    if (!sections.length) return;
    sections.forEach(function (sec) {
      if (sec.dataset.spot) return;
      sec.dataset.spot = '1';
      sec.addEventListener('mousemove', function (e) {
        var r = sec.getBoundingClientRect();
        sec.style.setProperty('--sx', ((e.clientX - r.left) / r.width * 100) + '%');
        sec.style.setProperty('--sy', ((e.clientY - r.top) / r.height * 100) + '%');
      });
    });
  }

  function init() {
    initGrain();
    initSpotlight();
    initReveal();
    initCounters();
    initProgress();
    initMarquee();
    initStickyAtc();
    initShipBar();
    initCursor();
    initScrollProgress();
    initMagnetic();
    initTilt();
    initMask();
    initHeroParallax();
    initWordCycle();
    initGarage();
    initBundle();
    initQuickAdd();
    initShopBar();
    initTtPhotos();
  }

  /* ---------- TikTok photo-post carousel (swipe + arrows + dots) ---------- */
  function initTtPhotos() {
    document.querySelectorAll('[data-tt-photo]').forEach(function (card) {
      if (card._ttInit) return;
      var track = card.querySelector('.oasis-tt-photo__track');
      var slides = card.querySelectorAll('.oasis-tt-photo__img');
      if (!track || slides.length < 2) return;
      card._ttInit = true;
      var prev = card.querySelector('.oasis-tt-photo__nav--prev');
      var next = card.querySelector('.oasis-tt-photo__nav--next');
      var dots = card.querySelectorAll('.oasis-tt-photo__dot');
      function index() { return Math.round(track.scrollLeft / track.clientWidth); }
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
      }
      function update() {
        var i = index();
        dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
      }
      if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); go(index() - 1); });
      if (next) next.addEventListener('click', function (e) { e.preventDefault(); go(index() + 1); });
      dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      update();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', init);
})();

/* ============================================================
 * In-page anchors (Builds / Events) + sweepstakes countdown
 * ============================================================ */
(function () {
  'use strict';

  // The events block is a third-party app section with a dynamic id; expose a
  // stable #events anchor so the "Upcoming Events" button can scroll to it.
  function ensureEventsAnchor() {
    if (document.getElementById('events')) return;
    var ev = document.querySelector('[id*="17793923427ba7a7c1"]');
    if (ev && ev.parentNode) {
      var a = document.createElement('span');
      a.id = 'events';
      a.style.cssText = 'display:block;position:relative;top:-80px;visibility:hidden;height:0;';
      ev.parentNode.insertBefore(a, ev);
    }
  }

  function smoothTo(el) {
    if (!el) return;
    var lenis = window.oasisLenis || window.lenis;
    if (lenis && typeof lenis.scrollTo === 'function') {
      lenis.scrollTo(el, { offset: -70, duration: 1.1 });
    } else {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href || href === '#') return;
    var target = href === '#events'
      ? (document.getElementById('events') || document.querySelector('[id*="17793923427ba7a7c1"]'))
      : document.querySelector(href);
    if (target) { e.preventDefault(); smoothTo(target); }
  });

  // Sweepstakes countdown to the real entries-close date (no invented numbers).
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  // Resolve a YYYY-MM-DD deadline to the exact instant of 23:59:59 in a fixed
  // time zone (default US Eastern, where Castro Oasis / West Haven CT is based).
  // DST-aware, so the giveaway closes at the same real moment for every visitor
  // regardless of their own device time zone.
  function deadlineMs(deadline, tz) {
    tz = tz || 'America/New_York';
    var fallback = new Date(deadline + 'T23:59:59').getTime(); // visitor-local, last resort
    var naive = Date.parse(deadline + 'T23:59:59Z'); // read the wall time as if it were UTC
    if (isNaN(naive)) return fallback;
    try {
      var at = new Date(naive);
      var asUTC = new Date(at.toLocaleString('en-US', { timeZone: 'UTC' })).getTime();
      var asTZ = new Date(at.toLocaleString('en-US', { timeZone: tz })).getTime();
      if (isNaN(asUTC) || isNaN(asTZ)) return fallback;
      return naive - (asTZ - asUTC); // shift the wall time into the target zone
    } catch (e) {
      return fallback;
    }
  }

  function initCountdown() {
    var els = document.querySelectorAll('[data-countdown]');
    if (!els.length) return;
    els.forEach(function (box) {
      if (box._cdTimer) clearInterval(box._cdTimer);
      var deadline = box.getAttribute('data-deadline');
      if (!deadline) return;
      var target = deadlineMs(deadline, box.getAttribute('data-tz'));
      var d = box.querySelector('[data-cd-days]'),
          h = box.querySelector('[data-cd-hours]'),
          m = box.querySelector('[data-cd-mins]'),
          s = box.querySelector('[data-cd-secs]');
      var tick = function () {
        var diff = target - Date.now();
        if (diff <= 0) {
          // In the sticky shop bar a permanent "closed" badge is just clutter next to
          // the buy button, so drop the whole counter instead.
          if (box.classList.contains('oasis-shopbar__count')) {
            box.style.display = 'none';
            clearInterval(box._cdTimer);
            return;
          }
          // Elsewhere (the sweepstakes section) swap the clock for the closed label.
          // Both class families are matched: the expired branch used to look only for
          // .oasis-sweep__* , so any other component was left showing "--d --h --m --s".
          var clock = box.querySelector('.oasis-sweep__clock, .oasis-shopbar__clock');
          if (clock) clock.innerHTML = '<span class="oasis-sweep__closed">' + (box.getAttribute('data-closed') || 'Entries are now closed') + '</span>';
          var lbl = box.querySelector('.oasis-sweep__countdown-label, .oasis-shopbar__count-label');
          if (lbl) lbl.style.display = 'none';
          clearInterval(box._cdTimer);
          return;
        }
        var days = Math.floor(diff / 86400000);
        var hrs = Math.floor((diff % 86400000) / 3600000);
        var mins = Math.floor((diff % 3600000) / 60000);
        var secs = Math.floor((diff % 60000) / 1000);
        if (d) d.textContent = days;
        if (h) h.textContent = pad(hrs);
        if (m) m.textContent = pad(mins);
        if (s) s.textContent = pad(secs);
      };
      tick();
      box._cdTimer = setInterval(tick, 1000);
    });
  }

  // Floating merch: fade + sharpen + scale into focus as the section enters view.
  function initFloatFocus() {
    var fl = document.querySelector('.oasis-reflection__float');
    if (!fl) return;
    if (!('IntersectionObserver' in window)) { fl.classList.add('in-focus'); return; }
    if (fl._focusIO) return;
    fl._focusIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) fl.classList.add('in-focus'); });
    }, { threshold: 0.2 });
    fl._focusIO.observe(fl);
  }

  /* ---------- Gallery lightbox (click to expand) ---------- */
  var lbState = { items: [], index: 0 };
  function lbEnsure() {
    var lb = document.querySelector('.oasis-lightbox');
    if (lb) return lb;
    lb = document.createElement('div');
    lb.className = 'oasis-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Photo viewer');
    lb.innerHTML =
      '<button type="button" class="oasis-lightbox__close" aria-label="Close">&times;</button>' +
      '<button type="button" class="oasis-lightbox__nav oasis-lightbox__nav--prev" aria-label="Previous photo">&#8249;</button>' +
      '<figure class="oasis-lightbox__stage"><img alt=""><figcaption class="oasis-lightbox__cap"></figcaption></figure>' +
      '<button type="button" class="oasis-lightbox__nav oasis-lightbox__nav--next" aria-label="Next photo">&#8250;</button>';
    document.body.appendChild(lb);

    lb.querySelector('.oasis-lightbox__close').addEventListener('click', lbClose);
    lb.querySelector('.oasis-lightbox__nav--prev').addEventListener('click', function () { lbStep(-1); });
    lb.querySelector('.oasis-lightbox__nav--next').addEventListener('click', function () { lbStep(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) lbClose(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('is-open')) return;
      if (e.key === 'Escape') lbClose();
      else if (e.key === 'ArrowLeft') lbStep(-1);
      else if (e.key === 'ArrowRight') lbStep(1);
    });
    // Touch: swipe left/right to navigate, swipe down to close
    var tx = 0, ty = 0;
    lb.addEventListener('touchstart', function (e) {
      if (e.touches.length !== 1) return;
      tx = e.touches[0].clientX; ty = e.touches[0].clientY;
    }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - tx;
      var dy = e.changedTouches[0].clientY - ty;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.4) lbStep(dx < 0 ? 1 : -1);
      else if (dy > 70 && Math.abs(dy) > Math.abs(dx) * 1.4) lbClose();
    }, { passive: true });
    return lb;
  }
  function lbShow() {
    var lb = lbEnsure();
    var item = lbState.items[lbState.index];
    if (!item) return;
    var img = lb.querySelector('.oasis-lightbox__stage img');
    var cap = lb.querySelector('.oasis-lightbox__cap');
    img.classList.remove('is-ready');
    img.onload = function () { img.classList.add('is-ready'); };
    img.src = item.full;
    img.alt = item.caption || '';
    cap.textContent = item.caption || '';
    cap.style.display = item.caption ? '' : 'none';
    var multi = lbState.items.length > 1;
    lb.querySelector('.oasis-lightbox__nav--prev').style.display = multi ? '' : 'none';
    lb.querySelector('.oasis-lightbox__nav--next').style.display = multi ? '' : 'none';
  }
  function lbOpen(items, index) {
    lbState.items = items;
    lbState.index = index;
    var lb = lbEnsure();
    lb.classList.add('is-open');
    // class on html too: body{overflow:hidden} no longer propagates to the
    // viewport because html carries overflow-x: clip (mobile hardening)
    document.body.classList.add('oasis-lightbox-open');
    document.documentElement.classList.add('oasis-lightbox-open');
    lbShow();
    lb.querySelector('.oasis-lightbox__close').focus();
  }
  function lbClose() {
    var lb = document.querySelector('.oasis-lightbox');
    if (!lb) return;
    lb.classList.remove('is-open');
    document.body.classList.remove('oasis-lightbox-open');
    document.documentElement.classList.remove('oasis-lightbox-open');
  }
  function lbStep(dir) {
    var n = lbState.items.length;
    if (!n) return;
    lbState.index = (lbState.index + dir + n) % n;
    lbShow();
  }
  function lbCollect(scope) {
    return Array.from(scope.querySelectorAll('[data-lightbox]')).map(function (el) {
      return { full: el.getAttribute('data-full'), caption: el.getAttribute('data-caption') || '' };
    });
  }
  function initLightbox() {
    document.querySelectorAll('[data-lightbox]').forEach(function (el) {
      if (el.dataset.lbBound) return;
      el.dataset.lbBound = '1';
      var activate = function () {
        var scope = el.closest('section') || document;
        var items = lbCollect(scope);
        var siblings = Array.from(scope.querySelectorAll('[data-lightbox]'));
        lbOpen(items, siblings.indexOf(el));
      };
      el.addEventListener('click', activate);
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); }
      });
    });
  }

  function boot() { ensureEventsAnchor(); initCountdown(); initFloatFocus(); initLightbox(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
